export default __webpack_public_path__ + "static/media/menu-icon.0258df5e.svg";